import IconStar from '../../options/IconStar';
import ResourceCounter from '../../options/ResourceCounter';

type SpellSlotProps = {
    name: string;
    total: number;
    spent: number;
    onChange: (
        spent: number,
    ) => void;
};


function SpellSlot({ name, total, spent, onChange }: SpellSlotProps) {
    return (
        <ResourceCounter
            name={name}
            total={total}
            spent={spent}
            Icon={IconStar}
            size={'2em'}
            iconStyle={{
                marginBottom: '0.5em',
                marginTop: '0.5em',
                marginLeft: '0.5em',
            }}
            onChange={onChange}
        />
    );
}

export default SpellSlot;